import {BenjiKIV} from "../BenjiKIV";
import {BenjiKIVSymbolStates, ISymbol} from "../../core/reel/ReelInterfaces";
import {gsap} from "gsap";
import {BenjiKIVStatics} from "../BenjiKIVStatics";

export class BenjiKIVSymbol extends PIXI.Container implements ISymbol {

    private _symbolName:string;
    private _originalName:string;
    private _state:BenjiKIVSymbolStates;
    private _isStacked:boolean;
    private _reelPosition:number;
    private _reelTargetPosition:number;
    protected _reelId:number;
    private _isRemoved:boolean;
    private _splitLevel:number;
    private _isUsed:boolean;
    private _newStateTL:gsap.core.Timeline;

    protected _darkOverlay:PIXI.Sprite;
    protected _currentStateSprite:PIXI.Sprite;
    protected _currentState2Sprite:PIXI.Sprite;
    protected _newStateSprite:PIXI.Sprite;
    protected _newState2Sprite:PIXI.Sprite;

    constructor() {
        super();
        this._isUsed = false;
        this._isStacked = false;
        this._currentStateSprite = new PIXI.Sprite();
        this._currentStateSprite.name = "currentStateSprite";
        this._currentStateSprite.anchor.set(0.5, 0.5);
        this._currentState2Sprite = new PIXI.Sprite();
        this._currentState2Sprite.name = "currentState2Sprite";
        this._currentState2Sprite.anchor.set(0.5, 0.5);
        this._currentState2Sprite.alpha = 0;
        this._newStateSprite = new PIXI.Sprite();
        this._newStateSprite.name = "newStateSprite";
        this._newStateSprite.anchor.set(0.5, 0.5);
        this._newStateSprite.alpha = 0;
        this._newState2Sprite = new PIXI.Sprite();
        this._newState2Sprite.name = "newState2Sprite";
        this._newState2Sprite.anchor.set(0.5, 0.5);
        this._newState2Sprite.alpha = 0;
        this._darkOverlay = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._darkOverlay.tint = 0x000000;
        this._darkOverlay.alpha = 0;
        this._darkOverlay.anchor.set(0.5, 0.5);
        this.setDarkOverlaySize();
        this.addChild(this._newStateSprite);
        this.addChild(this._currentStateSprite);
        this.addChild(this._newState2Sprite);
        this.addChild(this._currentState2Sprite);
        this.addChild(this._darkOverlay);
    }

    protected setDarkOverlaySize():void {
        this._darkOverlay.width = BenjiKIVStatics.symbolWidth;
        this._darkOverlay.height = BenjiKIVStatics.symbolHeight;
    }

    public init(initState:BenjiKIVSymbolStates):BenjiKIVSymbol {
        if(this.symbolName.indexOf("M") > -1 || this.symbolName.indexOf("W") > -1) {
            this.visible = false;
        } else {
            this.getNewStateAnimation(initState);
        }
        return this;
    }

    protected setState(state:BenjiKIVSymbolStates, textureName:string, changeSpeed:number = 0, newStateAlpha:number = 1):gsap.core.Timeline {
        if(this._newStateTL && this._newStateTL.isActive()) {
            this._newStateTL.pause();
            this._newStateTL.kill();
        }
        this._newStateTL = gsap.timeline();
        this._newStateTL.add(() => {
            this._state = state;
            this._newStateSprite.texture = BenjiKIV.assetLoader.getTextures(textureName)[0];
            if(this._splitLevel > 1) {
                this._newState2Sprite.texture = BenjiKIV.assetLoader.getTextures(textureName)[0];
            }
        });
        this._newStateTL.add([
            gsap.to(this._currentStateSprite, {
                duration : changeSpeed,
                alpha : 0,
                ease : "power2.in"
            }),
            gsap.to(this._newStateSprite, {
                duration : changeSpeed,
                alpha : newStateAlpha,
                ease : "power2.out"
            }),
            () => {
                if(this._splitLevel > 1) {
                    gsap.to(this._currentState2Sprite, {
                        duration : changeSpeed,
                        alpha : 0,
                        ease : "power2.in"
                    });
                    gsap.to(this._newState2Sprite, {
                        duration : changeSpeed,
                        alpha : newStateAlpha,
                        ease : "power2.out"
                    });
                }
            }

        ]);
        this._newStateTL.add(() => {
            this._currentStateSprite.texture = this._newStateSprite.texture;
            this._currentStateSprite.alpha = 1;
            this._newStateSprite.alpha = 0;
            if(this._splitLevel > 1) {
                this._currentState2Sprite.texture = this._newState2Sprite.texture;
                this._currentState2Sprite.alpha = 1;
                this._newState2Sprite.alpha = 0;
            }
        });

        return this._newStateTL;
    }

    public getNewStateAnimation(state:BenjiKIVSymbolStates, changeSpeed:number = 0, delay:number = 0, newStateAlpha:number = 1):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline({delay : delay});

        if(this._darkOverlay.alpha !== 0) {
            tl.to(this._darkOverlay, {duration : changeSpeed, alpha : 0});
        }

        if(this.state == state) {
            return tl;
        }

        let newTextureName:string;
        switch(state) {
            case BenjiKIVSymbolStates.WILD_2:
                newTextureName = this.symbolName + "/" + this.symbolName + "_2";
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case BenjiKIVSymbolStates.WILD_2_SPIN:
                newTextureName = this.symbolName + "/" + this.symbolName + "_2_spin";
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case BenjiKIVSymbolStates.WILD_3:
                newTextureName = this.symbolName + "/" + this.symbolName + "_3";
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case BenjiKIVSymbolStates.WILD_3_SPIN:
                newTextureName = this.symbolName + "/" + this.symbolName + "_3_spin";
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case BenjiKIVSymbolStates.WILD_DEAD:
                newTextureName = this.symbolName + "/" + this.symbolName + "_3_nowin";
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case BenjiKIVSymbolStates.WILD_DEAD_SPIN:
                newTextureName = this.symbolName + "/" + this.symbolName + "_3_nowin_spin";
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case BenjiKIVSymbolStates.M_DEAD:
                newTextureName = this.symbolName + "/" + this.symbolName + "_dead";
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case BenjiKIVSymbolStates.M_DEAD_SPIN:
                newTextureName = this.symbolName + "/" + this.symbolName + "_dead_spin";
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case BenjiKIVSymbolStates.NORMAL:
                newTextureName = this.symbolName + "/" + this.symbolName;
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case BenjiKIVSymbolStates.SPIN:
                newTextureName = this.symbolName + "/" + this.symbolName + "_spin";
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case BenjiKIVSymbolStates.NO_WIN:
                tl.add(gsap.to(this._darkOverlay, {duration : changeSpeed, alpha : 0.7}));
                break;
            case BenjiKIVSymbolStates.SPLIT:
                newTextureName = this.symbolName + "/" + this.symbolName + "_split";
                const adjustment:number = BenjiKIVStatics.symbolHeight / 4;
                tl.add([
                    this.setState(state, newTextureName, changeSpeed, newStateAlpha),
                    gsap.to(this._currentStateSprite.position, {
                        duration : changeSpeed,
                        y : (this._currentStateSprite.position.y - adjustment)
                    }),
                    gsap.to(this._newStateSprite.position, {
                        duration : changeSpeed,
                        y : this._newStateSprite.position.y - adjustment
                    }),
                    gsap.to(this._currentState2Sprite.position, {
                        duration : changeSpeed,
                        y : this._currentState2Sprite.position.y + adjustment
                    }),
                    gsap.to(this._newState2Sprite.position, {
                        duration : changeSpeed,
                        y : this._newState2Sprite.position.y + adjustment
                    })
                ]);
                break;
            case BenjiKIVSymbolStates.WIN:
                break;
            default:
        }

        if(tl.duration() == 0) {
            tl.add(gsap.to(this, {duration : 0.0001}));
        }

        return tl;
    }

    public reset():void {
        this._darkOverlay.alpha = 0;
        this._splitLevel = 1;
        this._currentStateSprite.position.y = 0;
        this._newStateSprite.position.y = 0;
        this._currentState2Sprite.position.y = 0;
        this._newState2Sprite.position.y = 0;
        this._currentStateSprite.alpha = 1;
        this._newStateSprite.alpha = 0;
        this.visible = true;
        this._currentState2Sprite.alpha = 0;
        this._newState2Sprite.alpha = 0;
        //Making sure state is correct before it can be re-used
        gsap.timeline({onComplete : () => {this._isUsed = false}}).add((<BenjiKIVSymbol>this).getNewStateAnimation(BenjiKIVSymbolStates.NORMAL));
    }

    get state():BenjiKIVSymbolStates {
        return this._state;
    }

    get reelPosition():number {
        return this._reelPosition;
    }

    set reelPosition(value:number) {
        this._reelPosition = value;
    }

    get reelId():number {
        return this._reelId;
    }

    set reelId(value:number) {
        this._reelId = value;
    }

    get isRemoved():boolean {
        return this._isRemoved;
    }

    get reelTargetPosition():number {
        return this._reelTargetPosition;
    }

    set reelTargetPosition(value:number) {
        this._reelTargetPosition = value;
    }

    get splitLevel():number {
        return this._splitLevel;
    }

    setSplitLevel(value:number):gsap.core.Timeline {
        this._splitLevel = value;
        return this.getNewStateAnimation(BenjiKIVSymbolStates.SPLIT, 0.11, 0.08);
    }

    get stackedSymbolName():string {
        return this._originalName;
    }

    set stackedSymbolName(value:string) {
        this._originalName = value;
    }

    get symbolName():string {
        return this._symbolName;
    }

    set symbolName(value:string) {
        this._symbolName = value;
    }

    get isUsed():boolean {
        return this._isUsed;
    }

    set isUsed(value:boolean) {
        this._isUsed = value;
    }

    get darkOverlay():PIXI.Sprite {
        return this._darkOverlay;
    }

    get isStacked():boolean {
        return this._isStacked;
    }

    set isStacked(value:boolean) {
        this._isStacked = value;
    }
}